<template>
  <div id="app">
    <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
      <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="/#/administrator">Easy Grader</a>
      <ul class="navbar-nav col-sm-3 col-md-2 mr-0 pr-0">
        <li class="nav-item pr-3 mt-2" v-if="isAuthorized">
          <select v-model="$i18n.locale">
            <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
          </select>
        </li>
        <li class="nav-item text-nowrap ">
          <img :src="profile.picture" class="thumbnail-img pull-left my-1 mr-2"  v-if="loggedIn" />
          <a class="nav-link" v-if="loggedIn" @click="logout">Sign out</a>
          <a class="nav-link" @click="login" v-if="!loggedIn">Login</a>

        </li>
        </ul>
    </nav>

    <div v-if="!isAuthorized">
        <div class="container-fluid">
            <div class="row">
                <main role="main" class="col ml-auto px-4 mt-5 mainAdmin">
                    Désolé,<span v-if="loggedIn"> {{profile.name}} </span> vous n'êtes pas autorisé à voir ces informations. Veuillez vous connecter s'il vous plait.
                </main>
            </div>
        </div>
    </div>
    <div class="container-fluid" v-if="isAuthorized">
        <div class="row">
            <nav class="col-md-2 d-none d-md-block bg-light sidebar">
              <div class="sidebar-sticky">
                <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                  Administration
                </h6>
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <router-link class="nav-link" exact-active-class="active" :to="{ name: 'Admin Home' }">
                      Accueil
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" exact-active-class="active" :to="{ name: 'Admin Leads' }">
                      Leads
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link" active-class="active" :to="{ name: 'Admin Survey' }">
                      Edition
                    </router-link>
                  </li>
                </ul>
                <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                  Avancé
                </h6>
                  <ul class="nav flex-column mb-2">
                    <li class="nav-item">
                      <router-link class="nav-link" exact-active-class="active" :to="{ name: 'Admin Settings' }">
                        Paramètres
                      </router-link>
                    </li>
                </ul>
              </div>
            </nav>
            <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4 mainAdmin">

                <router-view></router-view>

            </main>
        </div>
    </div>
  </div>
</template>


<script>

import { mapActions, mapGetters } from 'vuex';

// Templating
import Vue from 'vue'

export default {
  name: 'AdminBootstrap',

  data () {
    return {
      langs: ['fr', 'en']
    }
  },

  methods: {
    ...mapActions('user', {
        login: 'login',
        logout: 'logout'
      })
  },
  computed: {
      ...mapGetters('user', {
        profile: 'profile',
        loggedIn: 'loggedIn',
        isAuthorized: 'isAuthorized',
      })
    },
}

</script>


<style>

.form-control::placeholder {
  color: #ddd!important;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100; /* Behind the navbar */
  padding: 48px 0 0; /* Height of navbar */
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}
.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

.thumbnail-img {
    width: 30px;
    boarder: 1px solid #fff;
    border-radius: 30px;
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}

.mainAdmin {
  padding-top: 133px; /* Space for fixed navbar */
}

@media (min-width: 768px) {
  .mainAdmin {
    padding-top: 48px; /* Space for fixed navbar */
  }
}
/*
 * Navbar
 */

 .navbar-nav{
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
}

.navbar-brand {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: 0.8rem;
  font-weight: strong;
  background-color: rgba(0, 0, 0, .25);
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
}

.navbar.fixed-top {
    line-height: 21px;
    height: auto;
}

.nav-link {
    cursor: pointer;
}
</style>






// WEBPACK FOOTER //
// src/layouts/Adminlayout.vue